import React from 'react';

export default function btnSmall({ children, ...restProps }) {
  return (
    <button {...restProps} className={`flex  items-center justify-center text-center bg-primary-dark hover:border-2 hover:border-primary-dark hover:border-solid w-[140px] lg:w-150 h-14 text-primary-white`}>{children}</button>
  );
}
